// Framework and third-party non-ui
import React, { useEffect, useState } from 'react';

// App components
import Attribute from '../Attribute';

// JSON & Styles
import { makeStyles } from '@material-ui/core/styles';

import HikingIcon from 'assets/icons/option/DeTour ICO Sets_Trailhead.png';
import WalkingIcon from 'assets/icons/option/DeTour ICO Sets_Walk.png';
import RunningIcon from 'assets/icons/option/DeTour ICO Sets_Run.png';
import EBikesIcon from 'assets/icons/option/DeTour ICO Sets_E-Bike.png';
import HorsesIcon from 'assets/icons/option/Detour Icon Sets_Horse.png';
import ApvLessThan50Icon from 'assets/icons/option/Detour Icon Sets-56.png';
import ApvLessThan62Icon from 'assets/icons/option/Detour Icon Sets-56.png';
import ApvGreaterThan62Icon from 'assets/icons/option/Detour Icon Sets-56.png';
import OffRoadIcon from 'assets/icons/option/DeTour ICO Sets_ATV.png';
import SnowmobilingIcon from 'assets/icons/option/Detour Icon Sets_Snow mobile.png';
import CrossCountrySkiingIcon from 'assets/icons/option/Detour Icon Sets_Cross country.png';
import DogFriendlyIcon from 'assets/icons/option/DeTour ICO Sets_Pet.png';
import WheelchairFriendlyIcon from 'assets/icons/option/DeTour ICO Sets_Accessible.png';
import BoardwalkIcon from 'assets/icons/option/DeTour ICO Sets_Boardwalk Trail.png';
import PavedIcon from 'assets/icons/option/DeTour ICO Sets_Paved Trail.png';
import GravelIcon from 'assets/icons/option/DeTour ICO Sets_Gravel Trail.png';
import BicyclingIcon from 'assets/icons/option/DeTour ICO Sets_Bike.png';
import { primaryTypeCodes } from 'components/Filter/PopoverMenu/config';

const OptionAttribute = ({attribute, selected, setOptionAttribute, options, optionType}) => {
    const [clicked, setClicked] = useState(null);

    const useStyles = makeStyles({
        bicycleIcon: {
            backgroundImage: `url(${BicyclingIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        gravelIcon: {
            backgroundImage: `url(${GravelIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        pavedIcon: {
            backgroundImage: `url(${PavedIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        boardwalkIcon: {
            backgroundImage: `url(${BoardwalkIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        wheelchairFriendlyIcon: {
            backgroundImage: `url(${WheelchairFriendlyIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        dogFriendlyIcon: {
            backgroundImage: `url(${DogFriendlyIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        crossCountrySkiingIcon: {
            backgroundImage: `url(${CrossCountrySkiingIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        snowmobilingIcon: {
            backgroundImage: `url(${SnowmobilingIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        offroadIcon: {
            backgroundImage: `url(${OffRoadIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        apvGreaterThan62Icon: {
            backgroundImage: `url(${ApvGreaterThan62Icon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        apvLessThan62Icon: {
            backgroundImage: `url(${ApvLessThan62Icon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        apvLessThan50Icon: {
            backgroundImage: `url(${ApvLessThan50Icon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        horsesIcon: {
            backgroundImage: `url(${HorsesIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        eBikesIcon: {
            backgroundImage: `url(${EBikesIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        runningIcon: {
            backgroundImage: `url(${RunningIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        walkingIcon: {
            backgroundImage: `url(${WalkingIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        hikingIcon: {
            backgroundImage: `url(${HikingIcon})`,
            backgroundSize: 'contain',
            height: '20px',
            width: '20px',
            marginTop: '3px',
        },
        iconClicked: {
            filter: 'brightness(0) saturate(100%) invert(99%) sepia(4%) saturate(232%) hue-rotate(222deg) brightness(117%) contrast(100%)'
        },
        iconFlex: {
            display: 'flex',
            flexDirection: 'row',
            fontFamily: 'Open Sans',
            fontSize: '14px',
            lineHeight: '20px',
            letterSpacing: '0.25px',
            color: '#4D4D4D',
            marginTop: '8px',
            justifyContent: 'space-between',
        },
        clicked: {
            backgroundColor: '#4D7343 !important',
            color: '#ffffff !important',
        },
        clickable: {
            cursor: 'pointer'
        },
    });

    const classes = useStyles();

    useEffect(() => {
        setClicked(selected);
    }, [selected]);

    useEffect(() => {
        setOptionAttribute(attribute, clicked)
    }, [clicked]);

    useEffect(() => {
        if(options.hasOwnProperty(optionType)){
            if(options[optionType].hasOwnProperty(attribute)){
                setClicked(options[optionType][attribute]);
            }
        }
    }, []);



    const handleKeyUp = (e) => {
        if(e.keyCode === 13) setClicked(!clicked);
    };
    let accessibilityButtonAttrs = {tabindex:"0",role:"button",'aria-pressed':"false"};

    const activityTypeIcons = {
        'Hiking': 'hikingIcon',
        'Walking': 'walkingIcon',
        'Running': 'runningIcon',
        'Bicycling': 'bicycleIcon',
        'Horses': 'horsesIcon',
        'APV <50"': 'apvLessThan50Icon',
        'APV <62"': 'apvLessThan62Icon',
        'APV >62"': 'apvGreaterThan62Icon',
        'Off-Road 4x4"': 'offroadIcon',
        'Snowmobiling': 'snowmobilingIcon',
        'Cross-Country Skiing': 'crossCountrySkiingIcon',
      };
        
      const suitabilityTypeCodes = {
        'Dog Friendly': 'dogFriendlyIcon',
        'Wheelchair Friendly': 'wheelchairFriendlyIcon',
        'Boardwalk': 'boardwalkIcon',
        'Paved': 'pavedIcon',
        'Gravel': 'gravelIcon',
        'E-Bikes': 'eBikesIcon',
      };

    const getIconClasses = () => {
        let iconClasses = [];
        if(optionType === 'Activity Type'){
            iconClasses.push(classes[activityTypeIcons[attribute]])
        }else if(optionType === 'Suitability'){
            iconClasses.push(classes[suitabilityTypeCodes[attribute]])
        }
        if(clicked && iconClasses.length){
            iconClasses.push(classes.iconClicked)
        }
        return iconClasses;
    };

    if(clicked){
        return  (
            <Attribute
                iconClasses = {getIconClasses()}
                attribute={attribute} 
                optionClasses={[classes.clicked, classes.clickable]}
                onClick={() => {setClicked(false)}} 
                accessibilityButtonAttrs={{...accessibilityButtonAttrs, onKeyUp:((e) =>{handleKeyUp(e)})}}/>
        )
    }else{
        return  (
            <Attribute
                iconClasses = {getIconClasses()}
                attribute={attribute} 
                optionClasses={[classes.clickable]} 
                onClick={() => {setClicked(true)}} 
                accessibilityButtonAttrs={{...accessibilityButtonAttrs, onKeyUp:((e) =>{handleKeyUp(e)}) }} />
        )
    }
};

export default OptionAttribute;
